import { render } from "./SalonJobs.vue?vue&type=template&id=1d06b6d1&scoped=true"
import script from "./SalonJobs.vue?vue&type=script&lang=js"
export * from "./SalonJobs.vue?vue&type=script&lang=js"

import "./SalonJobs.vue?vue&type=style&index=0&id=1d06b6d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d06b6d1"]])

export default __exports__